import React from 'react';
import { ArrowRight } from 'lucide-react';
import { brainStates, stateById, sheetsFor } from '../../data/fastBrain';

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const lastDays = (n) => Array.from({ length: n }, (_, i) => { const d = new Date(); d.setDate(d.getDate() - (n - 1 - i)); return d; });

// 30-day pattern: dot calendar + how often each brain state showed up
export const MonthPattern = ({ checkins, testId = 'fb-month' }) => {
  const days = lastDays(30);
  const start = iso(days[0]);
  const list = (checkins || []).filter((c) => c.date >= start);
  const byDate = Object.fromEntries(list.map((c) => [c.date, c]));
  const counts = brainStates.map((s) => ({ s, n: list.filter((c) => c.state === s.id).length }));
  const max = Math.max(1, ...counts.map((c) => c.n));
  return (
    <div data-testid={testId}>
      <div className="grid grid-cols-10 gap-1.5 mb-5">
        {days.map((d) => {
          const c = byDate[iso(d)];
          const s = c && stateById(c.state);
          return <div key={iso(d)} title={`${d.toLocaleDateString()}${s ? ` · ${s.name}${c.note ? ` — ${c.note}` : ''}` : ''}`} className="aspect-square rounded-lg" style={{ background: s ? s.color : '#f1ece6' }} data-testid={`${testId}-${iso(d)}`} />;
        })}
      </div>
      <div className="space-y-1.5">
        {counts.map(({ s, n }) => (
          <div key={s.id} className="flex items-center gap-3">
            <span className="w-20 font-body text-sm font-semibold" style={{ color: s.color }}>{s.name}</span>
            <div className="flex-1 h-3 rounded-full bg-[#f1ece6] overflow-hidden"><div className="h-full rounded-full" style={{ width: `${(n / max) * 100}%`, background: s.color }} /></div>
            <span className="w-14 text-right font-body text-xs text-stone-500" data-testid={`${testId}-count-${s.id}`}>{n} day{n === 1 ? '' : 's'}</span>
          </div>
        ))}
      </div>
      <p className="mt-3 font-body text-xs text-stone-500">{list.length} check-in{list.length === 1 ? '' : 's'} in the last 30 days.</p>
    </div>
  );
};

// After a check-in: point to the worksheets for that brain state
export const SuggestedSheets = ({ stateId, onOpen }) => {
  const s = stateById(stateId);
  const list = sheetsFor(stateId);
  if (!s || !list.length) return null;
  return (
    <div className="rounded-2xl p-4 mb-6" style={{ background: s.bg }} data-testid="fb-suggested">
      <p className="font-body text-sm text-stone-700 mb-2">For a <strong style={{ color: s.color }}>{s.name}</strong> brain, try one of these:</p>
      <div className="flex flex-wrap gap-2">
        {list.map((sh, i) => (
          <button key={sh.id} type="button" onClick={() => onOpen(stateId, sh.id)} className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 font-body text-sm ${i === 0 ? 'text-white' : 'bg-white'}`} style={i === 0 ? { background: s.color } : { color: s.color }} data-testid={`fb-suggest-${sh.id}`}>
            {i === 0 && 'Start with '}{sh.title} <ArrowRight size={14} />
          </button>
        ))}
      </div>
    </div>
  );
};
